import { ALL_VALUE } from '../../Common/API/ItemsGetters'
import { SERVER_ALL_VALUE } from '../../Common/Constants/ServerValues'
import { notificationChannelsMapToString, notificationOrder, UserNotificationTypes } from './Constants'
import { ApplicationNotificationFormData, NotificationOrder, NotificationOrderModified } from './Types'
import { ApplicationResponseNotification, UserNotificationsType } from '../../../NonReact/common/Types/Types'

export const stateMapper = (
    state: ApplicationNotificationFormData,
    originalNotification: ApplicationResponseNotification,
    orderedUserNotifications: UserNotificationsType[],
    unwantedChannels: string[]
): ApplicationResponseNotification => {
    const modifiedOptioned: NotificationOrder[] = notificationOrder.filter(
        (order: NotificationOrder): boolean => order.modified === true
    )

    const notificationsEnabled: boolean = state?.settings?.enabled ?? true

    return {
        ...originalNotification,
        DoNotDisturb: !notificationsEnabled,
        NotificationsTelSysID: notificationsEnabled ? state?.settings?.telSysID ?? null : null,
        NotificationsPartitionIDInTelSys: notificationsEnabled ? state?.settings?.partitionIDInTelSys ?? null : null,
        NotificationsDeviceNumber:
            state?.settings?.deviceNumber === SERVER_ALL_VALUE || notificationsEnabled
                ? null
                : state?.settings?.deviceNumber ?? null,
        TelephoneNumber: notificationsEnabled ? state?.settings?.telephoneNumber ?? null : null,
        NotificationChannels: state?.settings?.channels.includes(ALL_VALUE)
            ? []
            : [
                  ...(state?.settings?.channels.map(
                      (channel: number): string => notificationChannelsMapToString[channel]
                  ) ?? []),
                  ...unwantedChannels
              ],
        UserNotifications: orderedUserNotifications.map(
            (userNotification: UserNotificationsType, index: number): UserNotificationsType => {
                const modifiedOption: Definable<NotificationOrderModified> = modifiedOptioned.find(
                    (order): boolean => order.name === userNotification.Name
                ) as Definable<NotificationOrderModified>

                return {
                    ...userNotification,
                    Threshold: modifiedOption
                        ? modifiedOption.unModifyFunction(
                              parseInt(state?.preferences?.[`${UserNotificationTypes.THRESHOLD}${index}`] as string, 10)
                          )
                        : parseInt(state?.preferences?.[`${UserNotificationTypes.THRESHOLD}${index}`] as string, 10),
                    NotificationEnabled:
                        (state?.preferences?.[`${UserNotificationTypes.STATUS}${index}`] as boolean) ??
                        userNotification.NotificationEnabled
                }
            }
        )
    } as ApplicationResponseNotification
}
